const fragShader = `
      precision mediump float;
      uniform sampler2D uMainSampler;
      varying vec2 outTexCoord;
      varying vec2 fragCoord;

      void main()
      {
            vec4 color = texture2D(uMainSampler, outTexCoord);
            gl_FragColor = vec4(color.r * 0.85, color.g * 0.85, color.b * 0.85, color.a);
      }
`;

export class DarkenPipeline extends Phaser.Renderer.WebGL.Pipelines.SinglePipeline {
      constructor(game) {
            super({
                  game,
                  fragShader,
                  uniforms: [
                        'uProjectionMatrix',
                        'uMainSampler'
                  ]
            });
      }
}